export const MeleeCombat = [
  {
    percent: '0%',
    blunt: 'hit ineffectively',
    sharp: 'hit ineffectively',
  },
  {
    percent: '0.0 - 0.7%',
    blunt: 'tap innocently',
    sharp: 'tap',
  },
  {
    percent: '0.7 - 1.4%',
    blunt: 'tickle lightly',
    sharp: 'tickle',
  },
  {
    percent: '1.4 - 2.0%',
    blunt: 'sting',
    sharp: 'sting sharply',
  },
  {
    percent: '2.0 - 2.7%',
    blunt: 'hurt mildly',
    sharp: 'graze',
  },
  {
    percent: '2.7 - 3.4%',
    blunt: 'strike badly',
    sharp: 'cut',
  },
  {
    percent: '3.4 - 4.7%',
    blunt: 'strike',
    sharp: 'slice',
  },
  {
    percent: '4.7 - 6.0%',
    blunt: 'send a bone crushing blow',
    sharp: 'slice horribly',
  },
  {
    percent: '6.0 - 7.4%',
    blunt: 'knock',
    sharp: 'shear to pieces',
  },
  {
    percent: '7.4 - 9.4%',
    blunt: 'slam mercilessly',
    sharp: 'strike with deadly force',
  },
  {
    percent: '9.4 - 11.4%',
    blunt: 'blast powerfully',
    sharp: 'mutilate',
  },
  {
    percent: '11.4 - 14.0%',
    blunt: 'destroy',
    sharp: 'dismember',
  },
  {
    percent: '14.0%+',
    blunt: 'destroy utterly',
    sharp: 'destroy utterly',
  },
];

export const SpellCombat = [
  {
    percent: '0%',
    magic: 'hit ineffectively',
  },
  {
    percent: '0.0 - 1.4%',
    magic: 'tap innocently',
  },
  {
    percent: '1.4 - 2.0%',
    magic: 'tickle lightly',
  },
  {
    percent: '2.0 - 3.4%',
    magic: 'sting',
  },
  {
    percent: '3.4 - 4.0%',
    magic: 'hurt mildly',
  },
  {
    percent: '4.0 - 5.4%',
    magic: 'strike badly',
  },
  {
    percent: '5.4 - 6.7%',
    magic: 'strike',
  },
  {
    percent: '6.7 - 8.7%',
    magic: 'send a bone crushing blow',
  },
  {
    percent: '8.7 - 10.7%',
    magic: 'knock',
  },
  {
    percent: '10.7 - 14.0%',
    magic: 'slam mercilessly',
  },
  {
    percent: '14.0 - 16.7%',
    magic: 'blast powerfully',
  },
  {
    percent: '16.7 - 20.7%',
    magic: 'destroy',
  },
  {
    percent: '20.7%+',
    magic: 'destroy utterly',
  },
];

export const HealthStatus = [
  {
    percent: '>90%',
    message: 'is in top shape',
  },
  {
    percent: '81% - 90%',
    message: 'is in decent shape',
  },
  {
    percent: '71% - 80%',
    message: 'is bruised',
  },
  {
    percent: '61% - 70%',
    message: 'is slightly injured',
  },
  {
    percent: '51% - 60%',
    message: 'is hurting',
  },
  {
    percent: '41% - 50%',
    message: 'is badly injured',
  },
  {
    percent: '31% - 40%',
    message: 'is bleeding terribly',
  },
  {
    percent: '21% - 30%',
    message: 'is terribly injured',
  },
  {
    percent: '11% - 20%',
    message: 'is near death',
  },
  {
    percent: '1% - 10%',
    message: 'is mortally wounded',
  },
];

export const ConsiderStatus = [
  {
    message: 'You will need the help of the gods to kill <target>',
  },
  {
    message: 'You will need an army of friends to help you kill <target>',
  },
  {
    message: "You shouldn't try to kill <target> without some help",
  },
  {
    message: '<target> will most likely beat you to a pulp',
  },
  {
    message: 'Fighting <target> would not be too wise',
  },
  {
    message: 'You will most likely lose to <target> in a fair fight',
  },
  {
    message: 'It would be a pretty even fight',
  },
  {
    message: 'You could probably beat <target> in a fair battle',
  },
  {
    message: 'You could possibly kill <target>',
  },
  {
    message: 'You should be able to take <target> without breaking a sweat',
  },
  {
    message: 'Why bother with such a little guy',
  },
];
